import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import { getAuthToken } from './authService';
import { baseURL } from './constants';

const baseQuery = () => fetchBaseQuery({
  baseUrl: baseURL,
  prepareHeaders: async (headers) => {
    const token = await getAuthToken()    
    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `${token}`)
    }
    return headers
  },
})

export default baseQuery